import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    { 
      id: '01',
      Nombre: i18n.t('tipos.correction_method.integra'),
    },
    { 
      id: '02',
      Nombre: i18n.t('tipos.correction_method.diferencias'),
    },
    { 
      id: '03',
      Nombre: i18n.t('tipos.correction_method.otras'),
    },
    { 
      id: '04',
      Nombre: i18n.t('tipos.correction_method.otras'),
    },
  ]
}

export function TIPOS_CORRECTION_METHOD (state) {
  return configHelper.getConfig(state, 'TIPOS_CORRECTION_METHOD', GenerateConfig)
}
